<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <el-card class="rightContent">
              <h3>
                试卷列表
                <span style="float: right">
                  <el-button type="primary" @click="goCreateNewPaper">
                    + 新建试卷</el-button
                  >
                </span>
              </h3>
              <el-divider></el-divider>
              <el-input
                v-model="paperKeyword"
                size="medium"
                placeholder="请输入检索关键词"
                style="width: 300px"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchPaper"
                ></el-button>
              </el-input>
              <el-table
                ref="filterTable"
                :data="paperList"
                style="width: 100%"
                v-loading="loading"
              >
                <el-table-column prop="name" label="名称" min-width="40%">
                </el-table-column>
                <el-table-column
                  prop="exams.length"
                  label="引用次数"
                  min-width="10%"
                >
                </el-table-column>
                <el-table-column
                  prop="updateTime"
                  label="更新时间"
                  min-width="20%"
                >
                  <template slot-scope="scope">
                    {{ scope.row.updateTime | timeFormatter }}
                  </template>
                </el-table-column>
                <el-table-column prop="delete" label="操作" min-width="20%">
                  <template slot-scope="scope">
                    <el-button
                      @click="usePaper(scope.row)"
                      type="primary"
                      size="small"
                      >使用</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalPage"
                style="float: right; margin: 20px"
                :current-page.sync="currentPage"
              >
              </el-pagination>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 优化点
import Leftbar from "../../components/newComponent/Leftbar";
import { paperListGet } from "../../api/paper";
import { timeFormatter } from "../../utils/filter";

export default {
  components: {
    Leftbar,
  },
  filters: { timeFormatter },
  name: "PaperUse",
  bodyClass: "index-page",
  data() {
    return {
      paperList: [
        {
          id: 1,
          name: "11",
          refCount: 11,
          updateTime: "111111",
        },
        { id: 11, name: "11", refCount: 11, updateTime: "111111" },
        {
          id: 111,
          name: "11",
          refCount: 11,
          updateTime: "111111",
        },
      ],
      paperKeyword: "",
      totalPage: 1,
      isManager: false,
      currentPage: 1,
      loading: false,
      selectedClass: {},
      taskId: "",
    };
  },
  mounted() {
    this.taskId = this.$route.query.taskId || "";
    this.initPaperList();
  },
  methods: {
    usePaper(row) {
      this.$router.push({
        path: `/task/detail/${this.taskId}`,
        query: {
          paperId: row.id,
        },
      });
    },
    initPaperList() {
      this.loading = true;
      paperListGet(this.paperKeyword, this.currentPage).then((res) => {
        this.paperList = res.content;
        this.totalPage = res.totalElements;
        this.loading = false;
      });
    },
    deletePaper(row) {},
    goCreateNewPaper() {
      this.$router.push("/paper/create");
    },
    searchPaper() {
      this.initPaperList();
    },
  },
  computed: {},
  watch: {
    currentPage(newVal, old) {
      this.initPaperList();
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
